import React from "react"
import PropTypes from "prop-types"
import VisuallyHidden from "../visually-hidden"
import Button from "."
import Icon from "../icon"
import cx from "classnames"

const SIZES = {
  sm: "w-8",
  md: "w-10",
  lg: "w-12"
}

/**
 * @param {Object} props
 * @param {"primary"|"secondary"|"tertiary"|"plain"} props.is
 * @param {"sm"|"md"|"lg"} props.size
 * @param {string} props.icon
 * @param props.label A11y label
 * @param className any custom classes to be applied to button
 */
const IconButton = React.forwardRef(
  ({ icon, label, size = "md", ...props }, ref) => {
    return (
      <Button
        {...props}
        size={size}
        className={cx(SIZES[size], props.className)}
        ref={ref}
      >
        <VisuallyHidden>{label}</VisuallyHidden>
        <Icon name={icon} className="pointer-events-none" />
      </Button>
    )
  }
)

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  className: PropTypes.string
}

export default IconButton
